const styles = () => ({
  position: 'relative',
  '& > div.dn-container': {
    zIndex: '99',
    position: 'relative',
    width: '100%',
    padding: '0 !important',
  },
  '.dn-sticky-box': {
    top: '30px',
    marginLeft: '0px',
    marginRight: '0px',
    marginTop: '0px',
    marginBottom: '0',
    padding: '0',
    border: 'none !important',
  },
  '.dn-text-datanomik': {
    maxWidth: '600px',
    minHeight: 'calc(100vh - 60px)',
    background: 'url(https://resources.datanomik.com/dashboard/images/login_bg.webp) 0 0 no-repeat',
    backgroundSize: '100% 100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '60px',
    boxSizing: 'border-box',
    borderRadius: '16px',
    '.dn-logo-white-small': {
      marginBottom: '30px',
    },
    '.DnkTypography-h3': {
      fontWeight: '500',
      lineHeight: '1.3',
      marginBottom: '30px',
      strong: {
        fontWeight: '500',
      },
    },
    '.DnkTypography-body1': {
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '18px',
      lineHeight: '1.3',
      color: '#fff',
      marginBottom: '30px',
      span: {
        color: '#FBB040',
        fontWeight: '400',
      },
      strong: {
        fontWeight: '400',
      },
    },
  },
  '.dn-legal': {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '1.2',
    color: '#fff',
  },
  '.dn-logo-mobile': {
    marginLeft: '12px',
  },
  '.dn-legal-mobile': {
    textAlign: 'center',
    display: 'block',
  },
  '.MuiDivider-root': {
    borderColor: 'rgba(229, 229, 229, 1)',
    margin: '14px 0',
  },
  '.dn-divider-buttons': {
    marginTop: '0',
    marginBottom: '0',
    '&, .DnkTypography-root': {
      fontSize: '12px',
      color: '#4B4B4B',
    },
  },
  '.DnkKeyIcon-root': {
    boxShadow: '0px 2px 4px 0px rgba(27, 28, 29, 0.04)',
  },
  '.dn-swiper-content': {
    padding: '12px',
  },
});

export default styles;
